const ICON_GRADIENT_COLOR = {
  red: "linear-gradient(180deg, #FD7860 0%, #DC4628 100%)",
  gold: "linear-gradient(180deg, #FFC72C 0%, #CD9E1D 100%)",
  green: "linear-gradient(180deg, #43D169 0%, #298F44 100%)",
  navy: "linear-gradient(180deg, #0C67E1 0%, #024093 100%)",
  blue: "linear-gradient(180deg, #36AEF3 0%, #0C67E1 100%)",
  indigo: "linear-gradient(180deg, #8764E7 0%, #4C1ED9 100%)",
  gray: "linear-gradient(180deg, #8C8EA8 0%, #3E4067 100%)",
  pink: "linear-gradient(180deg, #FF85F3 0%, #AA1F83 100%)",
  mint: "linear-gradient(180deg, #2AF9D6 0%, #00A286 100%)",
  orange: "linear-gradient(180deg, #F99541 0%, #C4702A 100%)",
  teal: "linear-gradient(180deg, #6FDCE9 0%, #339FAC 100%)",
  purple: "linear-gradient(180deg, #B16DF7 0%, #8E2CF1 100%)",
}

const ORGANIZATION_COLOR = {
  organizationBlue: "#3B7BEF",
  organizationBlueViolet: "#4C19DF",
  organizationBurgundy: "#7B1F40",
  organizationGreen: "#2E6421",
  organizationTeal: "#0B5F67",
  organizationBrickRed: "#AE1D11",
}

const PRIMARY_COLOR = {
  light: "#FBFBFF",
  dark: {
    50: "#E4E5E8",
    100: "#BBBEC6",
    200: "#8E92A1",
    300: "#61667B",
    400: "#3F465E",
    500: "#1D2542",
    DEFAULT: "#1D2542",
    600: "#1A213C",
    700: "#151B33",
    800: "#11162B",
    900: "#0A0D1D",
  },
}

const SECONDARY_COLOR = {
  dark: {
    200: "#ADAEC1",
    300: "#8C8EA8",
    400: "#737596",
    500: "#5A5D83",
    DEFAULT: "#5A5D83",
    600: "#52557B",
    700: "#484B70",
    800: "#3F4166",
    900: "#2E3053",
    1000: "#292B4C",
    1100: "#232442",
    1200: "#1D1E39",
  },
  gray: {
    200: "#BEBFC8",
    300: "#A4A5B1",
    400: "#9192A1",
    500: "#7D7F90",
    DEFAULT: "#7D7F90",
    600: "#757788",
    700: "#6A6C7D",
    800: "#606273",
    900: "#4D4F61",
    1000: "#464859",
    1100: "#3D3F4F",
    1200: "#343645",
  },
  light: {
    100: "#F4F5FB",
    200: "#ECEEF9",
    300: "#E4E7F6",
    400: "#DFE1F4",
    500: "#D9DCF2",
    DEFAULT: "#D9DCF2",
    600: "#D5D8F0",
    700: "#CFD3EE",
    800: "#CACEEC",
    900: "#C0C5E8",
    1000: "#BABFE5",
    1100: "#B2B8E2",
    1200: "#AAB0DE",
  },
  blue: {
    200: "#9BD7F9",
    300: "#72C6F7",
    400: "#54BAF5",
    500: "#36AEF3",
    DEFAULT: "#36AEF3",
    600: "#30A7F1",
    700: "#299DEF",
    800: "#2294ED",
    900: "#1684EA",
    1000: "#137CE7",
    1100: "#1071E4",
    1200: "#0C67E1",
  },
  purple: {
    100: "#BFB4E6",
    200: "#A991EE",
    300: "#8764E7",
    400: "#6D43E2",
    500: "#5322DD",
    DEFAULT: "#5322DD",
    600: "#4C1ED9",
    700: "#4219D4",
    800: "#3914CF",
    900: "#290CC7",
    1000: "#240AC1",
    1100: "#1F08BA",
    1200: "#1906B3",
  },
  red: {
    200: "#F9B4A6",
    300: "#F79582",
    400: "#F57F67",
    500: "#F3684C",
    DEFAULT: "#F3684C",
    600: "#F16045",
    700: "#EF553C",
    800: "#ED4B33",
    900: "#EA3A24",
    1000: "#E73420",
    1100: "#E42C1B",
    1200: "#E12516",
  },
  orange: {
    100: "#FEF3CC",
    200: "#FCE39B",
    300: "#FAD873",
    400: "#F9CF55",
    500: "#FFC72C",
    DEFAULT: "#FFC72C",
    600: "#F7C131",
    700: "#F6BA2A",
    800: "#F5B323",
    900: "#F3A616",
    1000: "#F19E13 ",
    1100: "#EF9510",
    1200: "#ED8B0C",
    1300: "#B86B06",
    1400: "#7A4500",
  },
  green: {
    200: "#A4E2D8",
    300: "#80D6C8",
    400: "#64CEBD",
    500: "#49C5B1",
    DEFAULT: "#49C5B1",
    600: "#42BFAA",
    700: "#39B8A1",
    800: "#31B098",
    900: "#21A388",
    1000: "#1D9B80 ",
    1100: "#189175",
    1200: "#14886B",
  },
  navy: {
    200: "#98BFF1",
    300: "#6EA5EB",
    400: "#4F92E6",
    500: "#3775E5",
    DEFAULT: "#3775E5",
    600: "#316DE2",
    700: "#2A62DE",
    800: "#2358DA",
    900: "#1645D3",
    1000: "#133ECE ",
    1100: "#1036C8",
    1200: "#0C2EC2",
  },
}

const success = SECONDARY_COLOR.green[800]
const error = SECONDARY_COLOR.red[800]
const warning = SECONDARY_COLOR.orange
const info = SECONDARY_COLOR.blue

const dropdownHover = "#E5F1FB"
// Default color assigned when using the shared/Select component which
//    uses the react-dropdown-select/ReactSelect imported library
const reactSelectItemDefault = "#0074D9"

module.exports = {
  ICON_GRADIENT_COLOR,
  ORGANIZATION_COLOR,
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  success,
  error,
  warning,
  info,
  dropdownHover,
  reactSelectItemDefault,
}
